import styled from '@emotion/styled';

export const EpisodeContentLabel = styled.h2`
  margin-bottom: 16px;
  color: #24203f;
  font-size: 2.4rem;
`;

export const UploaderStateContainer = styled.div<{
  containsMedia: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 140px;
  border: 1px #dedfe0
    ${({ containsMedia }) => (containsMedia ? 'solid' : 'dashed')};
  border-radius: 8px;
  background: #ffffff;
`;
